<template>
  <div class="col-12 carousel-container">
    <Splide :options="sliderOptions">
      <SplideSlide>
        <div class="landing-content">
          <video controls width="100%" autoplay loop muted preload="auto"
            src="../../../public/videos/welcome_vid.mp4"
            type="video/mp4"
            class="header-img"
            alt="Swampum"
          />
          <div class="carousel-content">
            <div class="text-content">
              <h3 class="mb-3 lead-title">
                Give&nbsp;stuff, get&nbsp;stuff, feel&nbsp;good!
              </h3>
              <p class="lead-banner">
                Swampum® is a unique online community where you can
                <strong>sell</strong> or <strong>buy</strong>,
                <strong>lend</strong> or <strong>borrow</strong> — even
                <strong>give</strong> and <strong>get free</strong> stuff! — with
                neighbors, friends, or anyone you’d like.
              </p>
            </div>
            <div class="card-buttons col-12">
              <SButtonMaterial
                class="register-button btn-size"
                buttonType="button"
                textColor="white"
                size="lg"
                color="primary"
                materialClass="dense"
                text="REGISTER"
                to="/signup"
                dataCy="lpRegisterBtn"
              />
              <SButtonMaterial
                class="about-button btn-size"
                buttonType="button"
                textColor="white"
                size="lg"
                color="transparent"
                materialClass="dense"
                text="LEARN MORE"
                to="/about-us"
              />
            </div>
          </div>
        </div>
      </SplideSlide>
      <!-- <SplideSlide>
        <div class="landing-content">
          <img
            src="https://media0.giphy.com/media/40QHcBMsJbK56644si/giphy.gif"
            class="header-img"
            alt="Swampum"
          />
          <div class="carousel-content content-for-comming-soon">

            <div>
              <div class="text-content">
                <h3 class="lead-title">
                  JOIN OUR GARAGE SALE COMMUNITY
                </h3>
                <p class="lead-banner">
                  Advertise your garage sale for free
                </p>
              </div>
              <div class="card-buttons col-12">
                <SButtonMaterial
                  class="register-button"
                  buttonType="button"
                  textColor="white"
                  size="lg"
                  color="primary"
                  materialClass="dense"
                  text="Check it out"
                  to="/garage-sales"
                />
              </div>
            </div>
            
          </div>
        </div>
      </SplideSlide> -->
    </Splide>

  </div>
</template>

<script>
import SButtonMaterial from "@/material-components/atoms/SButtonMaterial.vue";
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/splide/dist/css/themes/splide-default.min.css';


export default {
  name: "SLandingAboutContent",
  components: {
    SButtonMaterial,
    Splide,
    SplideSlide,

  },
  data() {
    return {
      sliderOptions : {
        type: 'slide',
        rewind: true,
        autoplay: true,
        interval: 3500,
      },
    }
  },
  methods: {
    openGarageSales() {
      return this.$router.push("/garage-sales");
    }
  },
};
</script>

<style lang="scss" scoped>
.carousel-container {
  max-width: 1300px;
  margin: auto;
  padding-top: 90px;
}
.teste {
  height: 312px;
}
.text-content {
  padding: 0 20px;
}
.landing-content {
  background: none;
  min-height: 276px;
  max-height: 312px;
  max-width: 72rem;
  padding: 0;
}
.carousel-content {
  position: absolute;
  padding: 20% 20px 20% 20px;
  width: 100%;
  left: 50%;
  background-color: #00000054;
  top: 50%;
  transform: translate(-50%, -50%);
  min-height: 100%;
}
.content-for-comming-soon {
  display: flex;
  align-items: center;
  justify-content: center;
}
.btn-size {
  width: 110px;
}
.lead-title {
  font-weight: 500;
  text-align: center;
  font-size: 30px;
  line-height: 38px;
  letter-spacing: 1.25px;
  color: white;
  text-transform: uppercase;
}
.lead-banner {
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 1.25px;
  text-align: center;
  color: white;
}
.card-buttons {
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 32px;
}
.header-img {
    max-width: 100%;
    position: absolute;
    z-index: -1;
    left: 0;
    top: -10%;
    padding: 0 !important
}
.about-button {
  border: 1px solid white;
  width: fit-content;
}
.splide{
  margin-bottom: 1rem;
}
@media screen and (max-width: 1024px) {
  .splide{
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem;
  }
  .carousel-container {
    padding-top: 138px;
  }
}
@media screen and (max-width: 870px) {
  .lead-banner {
    font-size: 10px;
  }
  .lead-title {
    font-size: 16px;
  }
  .md-subheader {
    display: none !important;
  }
  .splide{
    margin-top: -1rem !important;
    margin-bottom: 0.5rem;
  }
  .carousel-container {
    padding-top: 138px;
  }
}
@media screen and (min-width: 1199px) and (max-width: 1400px) {
  .carousel-container {
    max-width: 1110px;
  }
}
@media screen and (min-width: 1024px) and (max-width: 1198px) {
  .carousel-container {
    max-width: 900px;
  }
}
@media screen and (min-width: 800px) and (max-width: 1023px) {
  .carousel-container {
    max-width: 680px;
  }
}
@media screen and (min-width: 540px) and (max-width: 799px) {
  .carousel-container {
    max-width: 600px;
  }
}
</style>

<style>
.splide__track {
  min-height: 276px;
  max-height: 312px;
}
.splide__pagination {
  display: none;
}
.splide__arrows {
  display: none;
}
</style>